<template>
  <el-dialog
    title="人选offer反馈模板填写"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="60px"
    :modal="false"
    class="rpg-dialog"
  >
    <el-form :model="formData" label-width="130px" size="mini">
      <el-form-item label="候选人:">
        <span>{{ formData.候选人 }}</span>
      </el-form-item>
      <el-form-item label="推荐顾问:">
        <span>{{ formData.推荐顾问 }}</span>
      </el-form-item>
      <el-form-item label="人选意向:">
        <el-input v-model="formData.人选意向" placeholder="人选意向如何"></el-input>
      </el-form-item>
      <el-form-item label="人选诉求:">
        <el-input v-model="formData.人选诉求" placeholder="人选诉求如何"></el-input>
      </el-form-item>
      <el-form-item label="人选目前薪酬:">
        <el-input v-model="formData.人选目前薪酬" placeholder="人选现在的薪酬情况"></el-input>
      </el-form-item>
      <el-form-item label="人选期望薪酬:">
        <el-input v-model="formData.人选期望薪酬" placeholder="人选期望薪酬"></el-input>
      </el-form-item>
      <el-form-item label="人选目前职级:">
        <el-input v-model="formData.人选目前职级" placeholder="人选现在的职级情况"></el-input>
      </el-form-item>
      <el-form-item label="人选期望职级:">
        <el-input v-model="formData.人选期望职级" placeholder="人选期望职级"></el-input>
      </el-form-item>
      <el-form-item label="离职周期:">
        <el-input v-model="formData.离职周期" placeholder="人选离职周期"></el-input>
      </el-form-item>
      <el-form-item label="预计到岗时间:">
        <el-input v-model="formData.预计到岗时间" placeholder="人选预计到岗时间"></el-input>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item>
        <template slot="label">
          风险点:
          <el-popover placement="left" trigger="click" width="320" v-model="fengVisible">
            1、人选是否有竞业禁止？<br />
            2、家人是否同意？<br />
            3、人选是否有项目或者其他工作如果离开，公司会不同意。<br />
            4、我们是否做了他的背景调查（口碑评价），如果客户录用前背景调查是否会通不过？
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </template>
        <el-input v-model="formData.风险点" @focus="fengVisible = true" placeholder="人选可能存在的风险点"></el-input>
      </el-form-item>
      <el-form-item label="人选目前其他offer:">
        <el-input v-model="formData.人选目前其他offer" placeholder="人选目前其他offer"></el-input>
      </el-form-item>
      <el-form-item label="推进建议:">
        <el-input v-model="formData.推进建议" placeholder="给到客户&客户经理的建议"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onConfirm">确定</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      fengVisible: false,
      formData: {},
    }
  },
  methods: {
    open(formData) {
      this.formData = Object.assign({}, formData)
      this.dialogVisible = true
    },
    onConfirm() {
      let text = `【offer反馈】-${this.formData.候选人}\n 1）意向：${this.formData.人选意向}\n\n 2）关注点：\n 诉求：${
        this.formData.人选诉求
      }\n 薪酬职级：${this.formData.人选目前薪酬} ${this.formData.人选目前职级}\n\n 3）潜在的风险点：\n ${
        this.formData.风险点
      }\n\n 4）建议：\n ${this.formData.推进建议}\n\n 5）其他：\n 离职周期：${this.formData.离职周期}\n 预计到岗时间：${
        this.formData.预计到岗时间
      }\n 人选目前其他offer：${this.formData.人选目前其他offer}`
      const obj = JSON.parse(JSON.stringify(this.formData))
      this.$emit('confirm', { text, obj })
      this.dialogVisible = false
    },
  },
}
</script>
